var render = function render(){var _vm=this,_c=_vm._self._c;return _c('service-desk-list-app',{ref:"issuesListApp",attrs:{"ee-search-tokens":_vm.searchTokens}})
}
var staticRenderFns = []

export { render, staticRenderFns }